import { render, staticRenderFns } from "./relation-info.vue?vue&type=template&id=6bc39550&scoped=true"
import script from "./relation-info.vue?vue&type=script&lang=js"
export * from "./relation-info.vue?vue&type=script&lang=js"
import style0 from "./relation-info.vue?vue&type=style&index=0&id=6bc39550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc39550",
  null
  
)

export default component.exports